import styled from 'styled-components';
import SchemaEntityRelations from './SchemaEntityRelations';
import DataModelerPageHeader from './DataModelerPageHeader';
import ProgressLoaderModal from './ProgressLoaderModal';
import { verticalWrapperStyles } from './DataModelerCommonUI';
import DataModelerDataSourceInput from './DataModelerDataSourceInput';
import SchemaConfigValues from './SchemaConfigValues';
import { Tab, TabList, TabPanel, Tabs } from '../../../components/Tabs';
import DataModelerOptimizationTab from './DataModelerOptimizationTab';
import DataModelerMaxSchemaBanner from './DataModelerMaxSchemaBanner/DataModelerMaxSchemaBanner';
import useCustomerPlan from '../../../utils/hooks/useCustomerPlan';
import { useDataModelerContext } from '../DataModelerContext';
import DataModelerTables from './DataModelerTables';
import DataModelerFields from './DataModelerFields';

const Container = styled.div`
  ${verticalWrapperStyles};
`;

const DataModelerSchema = () => {
  const { maxSchemas } = useCustomerPlan();

  const { updateInProgress, lockedTtlSeconds, schemaObj } =
    useDataModelerContext();

  if (!schemaObj) {
    return null;
  }

  return (
    <Container>
      {(updateInProgress || lockedTtlSeconds > 0) && <ProgressLoaderModal />}
      <DataModelerMaxSchemaBanner maxSchemas={maxSchemas} />
      <DataModelerPageHeader />
      <Tabs>
        <TabList>
          <Tab tabIndex={0}>Configuration</Tab>
          <Tab tabIndex={1}>Connection</Tab>
          <Tab tabIndex={2}>Tables</Tab>
          <Tab tabIndex={3}>Fields</Tab>
          <Tab tabIndex={4}>Optimization</Tab>
          <Tab tabIndex={5}>View Model</Tab>
        </TabList>
        <TabPanel tabIndex={0}>
          <SchemaConfigValues />
        </TabPanel>
        <TabPanel tabIndex={1}>
          <DataModelerDataSourceInput />
        </TabPanel>
        <TabPanel tabIndex={2}>
          <DataModelerTables />
        </TabPanel>
        <TabPanel tabIndex={3}>
          <DataModelerFields />
        </TabPanel>
        <TabPanel tabIndex={4}>
          <DataModelerOptimizationTab />
        </TabPanel>
        <TabPanel tabIndex={5}>
          <SchemaEntityRelations dataModel={schemaObj} />
        </TabPanel>
      </Tabs>
    </Container>
  );
};

export default DataModelerSchema;
